import { useQuery } from '@tanstack/react-query';

import { DateTime } from 'luxon';
import { EventReport, EventReportClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const eventReportClient = new EventReportClient(apiBaseUrl);

function useGetUnattachedEventReports(cutoffDate: string) {
  return useQuery<EventReport[]>({
    queryKey: [queryKeys.EventReport.Unattached, cutoffDate],
    queryFn: () => eventReportClient.getUnattachedEventReports(cutoffDate),
    refetchOnMount: true,
  });
}
export default useGetUnattachedEventReports;
